module.exports = __webpack_public_path__ + "img/bg-create.31bc26c4.png";